import styled from '@emotion/styled';
import { Modal, Button, TextArea, Icon } from 'semantic-ui-react';



export const FullPageModal = styled(Modal)`
  &&& {
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    border-radius: 0 !important;

    .content {
      height: 100%;
      padding: 0 !important;
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f7f7f9;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: white;
  border-bottom: 1px solid #e5e5ea;
  position: relative;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444444;
  font-size: 24px;
  transition: all 0.2s ease;

  &:hover {
    color: #ff5252;
    transform: scale(1.1);
  }
`;

export const HeaderTitle = styled.h2`
  font-family: Lato;
  font-size: 24px;
  font-weight: bold;
  color: #444444;
  margin: 0;
`;

export const StickyButton = styled(Button)`
  &&& {
    background-color: #ff5252;
    color: white;
    font-weight: bold;
    border-radius: 5px;
    padding: 12px 24px;
    position: sticky;
    top: 20px;
    z-index: 1000;

    &:hover {
      background-color: #e04848;
    }
  }
`;

export const FeedbackButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-left: auto;
  margin-right: 20px;
`;

export const FeedbackButton = styled.button<{ positive?: boolean }>`
  background-color: ${props => (props.positive ? '#4caf50' : '#f44336')};
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const LeftPanel = styled.div`
  flex: 1;
  background-color: white;
  border-right: 1px solid #e5e5ea;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const RightPanel = styled.div`
  width: 650px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const DocumentSelectionArea = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const ProcessButton = styled(Button)`
  &&& {
    background-color: #ff5252;
    color: white;
    font-weight: bold;
    border-radius: 5px;
    padding: 12px 32px;
    margin-top: 20px;

    &:hover {
      background-color: #e04848;
    }

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }
`;

export const IframeContainer = styled.div`
  flex: 1;
  overflow: hidden;
  padding: 20px;
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
`;

export const CoTypesList = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e5e5ea;
  max-height: 40%;
  overflow-y: auto;
`;

export const CoTypeItem = styled.div<{ active?: boolean }>`
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 5px;
  background-color: ${props => (props.active ? '#ff5252' : '#f7f7f9')};
  color: ${props => (props.active ? 'white' : '#444444')};
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: Lato;
  font-size: 14px;

  &:hover {
    background-color: ${props => (props.active ? '#e04848' : '#e5e5ea')};
  }
`;

export const TextAreaSection = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const StyledTextArea = styled(TextArea)`
  &&& {
    flex: 1;
    resize: none;
    border: 1px solid #e5e5ea;
    border-radius: 5px;
    padding: 12px;
    font-family: Lato;
    font-size: 14px;

    &:focus {
      border-color: #ff5252;
    }
  }
`;

export const Label = styled.label`
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  color: #444444;
  margin-bottom: 8px;
  display: block;
`;

export const LoadingOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: 20px;
`;

export const LoadingText = styled.div`
  font-family: Lato;
  font-size: 16px;
  color: #444444;
`;